import { httpClient } from "@/services";

export default {
	actions: {
		async onFeedback({ dispatch }, values) {
			try {
				const { data } = await httpClient.post('feedback', values);
				if (data.status) {
					dispatch('setAlert', { type: "success", message: "Thanks a lot for your feedback" });
				}
			} catch (e) {
				console.error(e);
			}
		}
	}
};
